import {
  CORE_LOAD_ALLSEAT_REQUEST,
  CORE_LOAD_ALLSEAT_SUCCESS,

  CORE_LOAD_SEATINFO_REQUEST,
  CORE_LOAD_SEATINFO_SUCCESS,

  CORE_LOAD_ALLDISABLESEAT_REQUEST,
  CORE_LOAD_ALLDISABLESEAT_SUCCESS,

  CORE_LOAD_DISABLESEATINFO_REQUEST,
  CORE_LOAD_DISABLESEATINFO_SUCCESS,

} from '../../types'

const initialState = []
export default {
  allSeat: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_ALLSEAT_REQUEST:
        return initialState

      case CORE_LOAD_ALLSEAT_SUCCESS:
        return action.payload

      default:
        return state
    }
  },
  seatInfo: (state = {}, action) => {
    switch (action.type) {
      case CORE_LOAD_SEATINFO_REQUEST:
        return {}

      case CORE_LOAD_SEATINFO_SUCCESS:
        return action.payload

      default:
        return state
    }
  },
  allDisableSeat: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_ALLDISABLESEAT_REQUEST:
        return initialState

      case CORE_LOAD_ALLDISABLESEAT_SUCCESS:
        return action.payload

      default:
        return state
    }
  },
  disableSeatInfo: (state = {}, action) => {
    switch (action.type) {
      case CORE_LOAD_DISABLESEATINFO_REQUEST:
        return {}

      case CORE_LOAD_DISABLESEATINFO_SUCCESS:
        return action.payload

      default:
        return state
    }
  },
}


// WEBPACK FOOTER //
// ./src/features/hotseat/reducer.js